<template>
  <v-dialog v-model="show" width="700" @click:outside="closeModal">
    <v-card>
      <!-- <h1>{{setting}}</h1> -->
      <v-card-title class="text-h5 white--text" style="background-color: #5087e6">
        {{ dialogSetting.title }}
      </v-card-title>

      <v-card-text>
        <v-form v-if="dialogSetting.views === null" ref="form" class="mx-2" lazy-validation @submit.prevent>
          <v-container>
            <slot
              v-if="dialogSetting.title === '新增網址規則' || dialogSetting.title === '更新網址規則'"
              name="help"
            ></slot>

            <slot
              v-if="dialogSetting.title === '新增網址規則' || dialogSetting.title === '更新網址規則'"
              name="url-description"
            ></slot>

            <v-row v-for="(item, idx) in dialogSetting.fields" :key="idx" align="center">
              <v-col md="12" class="pr-0 pl-0 pt-0 pb-0 mt-3">
                <!-- <v-checkbox
                                  v-model="is_same"
                                  :label="`同開始、結束時間`"
                                  v-if="item.label==='活動開始時間'"
                                  :color="$vuetify.theme.themes['dark']['primary']"
                            ></v-checkbox> -->

                <h4 v-if="item.type !== 'select' && item.type !== 'checkbox'">
                  {{ item.label }}
                </h4>

                <v-text-field
                  v-if="item.type === 'text' || item.type === undefined"
                  :key="update_key['text']"
                  v-model.trim="item.value"
                  :success="!!item.value"
                  :rules="
                    item.label === '實驗說明'
                      ? []
                      : item.label === '網址' || item.label === '完整網址' || item.label === '編輯器頁面'
                      ? [rules.required]
                      : []
                  "
                  outlined
                  height="12"
                  dense
                  :hint="item.hint"
                  validate-on-blur
                  color="primary"
                  :value="item.value"
                  @blur="handleInput(item)"
                ></v-text-field>

                <v-select
                  v-if="item.type === 'select' || item.type === undefined"
                  v-model="item.value"
                  :items="item.items"
                  :label="item.label"
                  color="primary"
                  outlined
                  style="margin-top: 20px"
                  @change="check_by_select"
                ></v-select>

                <v-chip-group
                  v-if="item.type === 'update_rule' || item.type === undefined"
                  column
                  active-class="primary--text"
                >
                  <v-chip
                    v-for="(chip, index) in item.value"
                    :key="chip"
                    outlined
                    close
                    close-icon="mdi-close"
                    @click:close="removeChip(index)"
                  >
                    <span class="custom-chip">{{ chip }}</span>
                  </v-chip>
                </v-chip-group>

                <v-text-field
                  v-if="item.type === 'update_rule' || item.type === undefined"
                  ref="update_rule_input"
                  v-model="item.newValue"
                  :success="!!item.newValue"
                  placeholder="或..."
                  validate-on-blur
                  dense
                  autocomplete="on"
                  color="primary"
                  @input="check_by_rule_str(item.newValue)"
                  @keyup.enter="addChip(item.newValue)"
                ></v-text-field>

                <v-text-field
                  v-if="item.type === 'rule' || item.type === undefined"
                  v-model="item.value"
                  :success="!!item.value"
                  :rules="[rules.required]"
                  outlined
                  height="12"
                  dense
                  :hint="item.hint"
                  autocomplete="on"
                  color="primary"
                  placeholder="值"
                  @input="check_by_rule_str(item.value, item)"
                ></v-text-field>

                <v-container
                  v-if="item.type === 'check_rule' || item.type === undefined"
                  style="background-color: #f1f3f4; border-radius: 3px; padding: 12px"
                >
                  <v-card-title>檢查您的規則</v-card-title>
                  <v-card-text
                    >請在下方輸入網址以確定上述條件適用，並請確認您複製的是瀏覽器網址列中顯示的完整網址。</v-card-text
                  >
                  <v-row align="center" justify="center" class="d-flex" style="margin: 0px">
                    <v-col cols="10">
                      <v-text-field
                        v-model="check_url"
                        v-debounce-vtext:input="validateUrl"
                        outlined
                        placeholder="請輸入正確網址"
                        color="primary"
                        @blur="handleCheckUrl(check_url)"
                      >
                      </v-text-field>
                    </v-col>

                    <v-col cols="2">
                      <v-btn :disabled="is_validate" @click="check_url_rule(check_url)"> 檢查 </v-btn>
                    </v-col>
                  </v-row>

                  <transition-group name="list">
                    <v-card v-for="(item, index) in url_items" :key="item.id" class="px-2" style="margin-bottom: 20px">
                      <v-row wrap align="center">
                        <v-col cols="auto">
                          <v-icon v-show="item.isValid === false" color="red">mdi-cancel</v-icon>
                          <v-icon v-show="item.isValid" color="green">mdi-check-circle-outline</v-icon>
                        </v-col>
                        <v-col>
                          <span>{{ item.check_url }}</span>
                        </v-col>
                        <v-col cols="auto">
                          <v-btn icon @click="remove(index)">
                            <v-icon>mdi-minus-circle-outline</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                  </transition-group>
                </v-container>

                <v-container
                  v-if="item.type === 'target_object' || item.type === undefined"
                  style="background-color: #f1f3f4; border-radius: 3px"
                >
                  <!-- <v-list-item-group
                                color="primary"
                              >
                                <v-list>
                                  
                                  <v-list-item>
                                    <v-list-item-content>
                                      <v-list-item-title>Google Analytics (分析) 目標對象</v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                  <v-list-item>
                                    <v-list-item-content>
                                      <v-list-item-title>Google Ads</v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-list>
                              </v-list-item-group -->
                </v-container>

                <v-slider
                  v-if="item.type === 'slider' || item.type === undefined"
                  v-model="item.value"
                  thumb-label="always"
                  thumb-color="primary"
                  track-color="primary"
                  color="primary"
                  :max="item.max"
                  :min="item.min"
                >
                  <template #append>
                    <v-text-field
                      v-model="item.value"
                      class="mt-0 pt-0"
                      hide-details
                      single-line
                      type="text"
                      style="width: 60px"
                    ></v-text-field>
                    <span>%</span>
                  </template>
                </v-slider>

                <template v-if="item.grids !== null">
                  <v-row cols="12" class="d-flex">
                    <v-col v-for="item in item.grids" :key="item.id" cols="6">
                      <v-menu
                        v-if="item.type === 'date'"
                        v-model="item.is_show"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                        @blur="closeModal(item)"
                      >
                        <template #activator="{ on, attrs }">
                          <v-text-field
                            v-model="item.value"
                            :label="item.hint"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            :rules="
                              item.label === '開始時間' || item.label === '結束時間' || item.label === '實驗時間'
                                ? [rules.required]
                                : []
                            "
                            color="#5087e6"
                            v-on="on"
                          ></v-text-field>
                        </template>

                        <v-date-picker
                          v-model="item.value"
                          locale="zh-cn"
                          header-color="#5087e6"
                          color="#5087e6"
                          @input="item.is_show = false"
                        ></v-date-picker>
                      </v-menu>

                      <v-menu
                        v-if="item.type === 'time'"
                        v-model="item.is_show"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template #activator="{ on, attrs }">
                          <v-text-field
                            v-model="item.value"
                            :label="item.hint"
                            prepend-icon="mdi-clock-time-four-outline"
                            readonly
                            v-bind="attrs"
                            :rules="[rules.required]"
                            color="#5087e6"
                            v-on="on"
                          ></v-text-field>
                        </template>

                        <v-time-picker
                          v-model="item.value"
                          locale="zh-cn"
                          header-color="#5087e6"
                          color="#5087e6"
                          format="24hr"
                          @click="item.is_show = false"
                        ></v-time-picker>
                      </v-menu>
                    </v-col>

                    <!-- <v-col cols="6" v-if="item.type === 'time'"> -->
                    <!-- <v-menu
                                      ref="menu"
                                      v-model="item.is_show"
                                      :close-on-content-click="false"
                                      :nudge-right="40"
                                      transition="scale-transition"
                                      offset-y
                                      max-width="290px"
                                      min-width="290px"
                                      cols="6" v-if="item.type === 'time'"
                                    >
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                          v-model="item.value"
                                          :label="item.hint"
                                          prepend-icon="mdi-clock-time-four-outline"
                                          readonly
                                          v-bind="attrs"
                                          v-on="on"
                                          color="#5087e6"
                                        ></v-text-field>
                                      </template>
                                      <v-time-picker
                                        v-model="item.value"
                                        @input="item.is_show = false"
                                        locale="zh-cn"
                                        header-color="#5087e6"
                                        color="#5087e6"
                                        format="24hr"
                                        use-seconds
                                      ></v-time-picker>
                                    </v-menu> -->

                    <!-- </v-col> -->
                  </v-row>
                </template>

                <v-checkbox
                  v-if="item.type === 'checkbox' || item.type === undefined"
                  v-model="item.value"
                  :label="item.label"
                  color="primary"
                >
                </v-checkbox>

                <template v-if="item.type === 'select' && item.items === null">
                  <v-stepper v-model="e6" vertical style="margin-top: 20px">
                    <v-stepper-step :complete="e6 > 1" step="1">
                      取得綁定token
                      <small>Summarize if needed</small>
                    </v-stepper-step>
                    <v-stepper-content step="1">
                      <!-- <v-card
                                  >
                                    <v-text-field
                                      solo
                                      clearable
                                      disabled
                                      placeholder="點擊按鈕取得綁定Token"
                                      v-model="token"
                                  >
                                  </v-text-field>
                                  <v-btn
                                    @click="registerGroup"
                                  >
                                    <v-icon
                                    >
                                      mdi-clipboard-multiple-outline
                                    </v-icon>
                                  </v-btn>
                                  </v-card> -->
                      <div
                        :style="{
                          position: 'relative',
                          overflowX: 'auto',
                        }"
                      >
                        <v-textarea
                          ref="token"
                          value="<!-- Google Tag Manager (noscript) --><script>example</script><!-- End Google Tag Manager (noscript) -->"
                          no-resize
                          readonly
                          outlined
                          name="input-7-4"
                          :style="{
                            padding: '0px 24px 0px',
                            borderColor: '#dadce0',
                            borderRadius: '4px',
                          }"
                        ></v-textarea>
                        <button
                          :style="{
                            position: 'absolute',
                            top: '15px',
                            right: '40px',
                            cursor: 'pointer',
                          }"
                          @click="copyToClipboard('token')"
                        >
                          <v-icon> mdi-clipboard-multiple-outline </v-icon>
                        </button>
                      </div>
                      <v-btn color="primary" @click="e6 = 2"> 下一步 </v-btn>
                    </v-stepper-content>
                    <v-stepper-step :complete="e6 > 2" step="2"> Configure analytics for this app </v-stepper-step>

                    <v-stepper-content step="2">
                      <v-card> </v-card>
                      <v-btn color="primary" @click="e6 = 3"> 下一步 </v-btn>
                      <v-btn text @click="e6 = 1"> 回上一步 </v-btn>
                    </v-stepper-content>
                  </v-stepper>
                  <v-select v-model="item.value" :items="item.receiver_items" :label="`接收者名稱`"></v-select>
                </template>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
        <v-form v-if="dialogSetting.views !== null" ref="form" class="mx-2" lazy-validation>
          <v-data-table :headers="dialogSetting.headers" :items="dialogSetting.views" hide-default-footer>
            <template #[`item.priority`]="props">
              <v-edit-dialog
                :return-value.sync="props.item.priority"
                persistent
                large
                locale="zh-cn"
                transition="slide-x-transition"
                cancel-text="取消"
                save-text="保存"
                cancel-text-color="blue"
                @save="save(props.item)"
                @cancel="cancel(props.item)"
                @open="open(props.item)"
                @close="close(props.item)"
              >
                {{ props.item.priority }}
                <template #input>
                  <div class="mt-4 text-h6">更新權重</div>
                  <v-text-field
                    v-model="props.item.priority"
                    type="number"
                    label="Edit"
                    single-line
                    counter
                    autofocus
                    locale="zh-cn"
                    :rules="[rules.number]"
                    color="primary"
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </template>
          </v-data-table>
          <v-container>
            <v-row align="center">
              <v-col class="d-flex justify-end mb-6">
                <h4 v-if="now_rate < 100" style="color: red">總和必須等於100%。</h4>
                <h4 v-if="now_rate > 100" style="color: red">總和不得大於100%。</h4>
                <h4 style="margin-left: 40px">
                  {{ `${now_rate}%` }}
                </h4>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions v-if="dialogSetting.type !== 'target_object'">
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="closeModal"> 取消 </v-btn>
        <v-btn color="primary" text :disabled="isValid" @click="submit">
          {{ dialogSetting.submit_text }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-snackbar v-model="snackbar">已複製到剪貼簿</v-snackbar>
  </v-dialog>
</template>

<script>
// import Vuex Helper
import { mapGetters } from 'vuex'

import { apiPatchRegisterGroup } from '@/api/notify.js'

export default {
  name: 'ContainerNew',
  components: {},
  props: {
    dialogSetting: {
      type: Object,
      // default: '預設值',
      // required: true,
    },
  },
  data: function () {
    return {
      container_name: '',
      container_domain: '',
      show: true,
      rules: this.$utils.field_rules,
      now_rate: null,
      edit_views_item: {},
      e6: 1,
      // childRegisterGroupToken: this.registerGroupToken.register_group_token,
      snackbar: false,
      url_items: [],
      check_url: '',
      is_validate_url: true,
      rule_str: '',
      url_str: '',
      local: this.dialogSetting.fields,
      local_date: {},
      is_check_campaign_start: false,
      is_check_campaign_end: false,

      is_same: false,
      time: null,
      menu2: false,
      modal2: false,
      local_fields_0_value: this.dialogSetting.fields[0]['value'],
      update_key: {
        text: 1,
      },
    }
  },
  created: async function () {
    console.log('in_dialog', this.dialogSetting)
    // console.log(this.childRegisterGroupToken);
    if (this.dialogSetting.views !== null) {
      this.calculate_now_rate(this.dialogSetting.views)
    }
  },
  mounted: function () {
    console.log('yo Dialog')
  },
  computed: {
    isValid() {
      // return ( this.now_rate !== null && (this.now_rate < 95 || this.now_rate > 100) )
      return (
        (this.now_rate !== null && this.now_rate !== 100) ||
        (this.dialogSetting.title.includes('網址規則') &&
          (this.dialogSetting.fields[2]['value'] === null || this.dialogSetting.fields[2]['value'] === ''))
      )
    },
    ...mapGetters(['selectedAdmin', 'selectedOrg', 'selectedContainer']),
    is_validate() {
      return this.is_validate_url
    },
  },
  methods: {
    handleCheckUrl(url) {
      this.check_url = decodeURIComponent(url)
    },
    check_by_select() {
      console.log(this.dialogSetting.fields)
      if (this.dialogSetting.fields[0]['value'] === '完整網址') {
        this.$emit('changeRuleItems')
      }
      let conditional = this.dialogSetting.fields[1]['value']
      console.log(conditional)
      this.url_items = this.url_items.reduce((acc, cur) => {
        return [
          ...acc,
          { ...cur, isValid: this.check_from_url(conditional, decodeURIComponent(cur.check_url), this.url_str) },
        ]
      }, [])
    },
    check_by_rule_str(val, item) {
      console.log(val)
      console.log(this.url_items)
      try {
        console.log('parse_url')
        item.value = decodeURIComponent(item.value)
        console.log(item.value)
      } catch (error) {
        console.log('not_url')
      }
      // 如果要檢查的網址一個都沒有就直接return
      if (this.url_items.length == 0) return
      console.log('587', val)
      console.log(this.dialogSetting.fields[2]['value'])
      let conditional
      let url_type = this.dialogSetting.fields[0]['value']
      if (Array.isArray(this.dialogSetting.fields[2]['value'])) {
        conditional = this.dialogSetting.fields[1]['value']
        this.url_items = this.url_items.reduce((acc, cur) => {
          // return [ ...acc, {...cur, isValid : this.check_from_url(conditional, decodeURIComponent(cur.check_url), val) } ]
          return [...acc, { ...cur, isValid: this.check_from_url(conditional, decodeURIComponent(cur.check_url), val) }]
        }, [])

        if (this.url_items[0]['isValid']) return
        console.log(this.url_items)

        val = this.dialogSetting.fields[2]['value']
        this.url_items = this.url_items.reduce((acc, cur) => {
          // return [ ...acc, {...cur, isValid : this.check_from_url(conditional, decodeURIComponent(cur.check_url), val) } ]
          return [
            ...acc,
            { ...cur, isValid: this.url_switch(url_type, conditional, decodeURIComponent(cur.check_url), val) },
          ]
        }, [])
      } else {
        this.url_str = val
        conditional = this.dialogSetting.fields[1]['value']
        this.url_items = this.url_items.reduce((acc, cur) => {
          // return [ ...acc, {...cur, isValid : this.check_from_url(conditional, decodeURIComponent(cur.check_url), val) } ]
          return [...acc, { ...cur, isValid: this.check_from_url(conditional, decodeURIComponent(cur.check_url), val) }]
        }, [])
      }

      console.log(this.url_items)
    },
    check_url_rule(url) {
      console.log(url)
      console.log(this.dialogSetting.fields)
      let conditional = this.dialogSetting.fields[1]['value']
      console.log(conditional)
      if (conditional === null) {
        this.$root.vtoast.show({
          message: `尚未選擇規則，無法檢查！`,
          color: 'accent',
        })
        return
      }
      console.log('633', this.dialogSetting.fields)
      this.url_items.push({
        id: Date.now(),
        check_url: url,
        isValid: this.check_from_url(conditional, url, this.url_str),
      })
      this.check_by_rule_str(this.dialogSetting.fields[2]['newValue'])
      this.check_url = ''
    },
    check_from_url(conditional, url, val) {
      console.log(conditional)
      console.log(url)
      console.log(val)
      let result = false
      url = decodeURIComponent(url)
      console.log(this.local)
      console.log(this.local[2]['value'])
      console.log(this.dialogSetting.fields[0]['value'])
      console.log(this.dialogSetting.fields[1]['value'])
      console.log(this.dialogSetting.fields)

      let url_type = this.dialogSetting.fields[0]['value']
      console.log(url_type)
      if (!val) {
        if (!this.dialogSetting.fields[2]['value']) {
          console.log('1')
          val = decodeURIComponent(this.local[2]['value'])
        } else {
          console.log('2')
          if (this.local[2]['value']) {
            console.log('2.5')
            Array.isArray(this.local[2]['value'])
              ? (val = this.local[2]['value'])
              : (val = decodeURIComponent(this.local[2]['value']))
          } else {
            console.log('3')
            val = decodeURIComponent(this.dialogSetting.fields[2]['value'])
          }
        }
      } else {
        console.log('4')
        val = decodeURIComponent(val)
      }

      result = this.url_switch(url_type, conditional, url, val)

      return result
    },
    /**
     * @description 此函數根據提供的url_type分析URL，應用某些條件，並返回結果。
     *
     * @function
     * @name url_switch
     * @param {string} url_type - 進行URL分析的類型。可能是以下之一： "網址"，"主機"，"路徑"，"網址片段"。任何其他值都將導致一個帶有'未定義'的提示。
     * @param {string} conditional - 規則(例如:包含、不包含、等於、不等於...)
     * @param {string} url - 輸入要來檢查的URL。
     * @param {string} val - 輸入要用來檢查URL的值。
     * @returns {boolean} result - 基於提供的url_type，conditional和val的分析結果。
     */
    url_switch(url_type, conditional, url, val) {
      console.log(conditional)
      console.log('輸入的網址', url)
      console.log('輸入的值', val)
      console.log('輸入的值的型態', Array.isArray(val)) // 是陣列的話會回傳true
      let analyze_url
      let result = false
      let is_ok
      switch (url_type) {
        case '完整網址':
          is_ok = this.check_is_array(conditional, url, val)
          if (is_ok) {
            result = is_ok
            return result
          }
          result = this.rule_switch(conditional, url, val)
          break

        case '主機':
          analyze_url = new URL(url)
          console.log(analyze_url)
          analyze_url = analyze_url['hostname']
          is_ok = this.check_is_array(conditional, analyze_url, val)
          if (is_ok) {
            result = is_ok
            return result
          }
          result = this.rule_switch(conditional, analyze_url, val)
          break

        case '路徑':
          analyze_url = new URL(url)
          console.log(analyze_url)
          analyze_url = analyze_url['pathname']
          is_ok = this.check_is_array(conditional, analyze_url, val)
          if (is_ok) {
            result = is_ok
            return result
          }
          result = this.rule_switch(conditional, analyze_url, val)
          break

        case '網址片段':
          analyze_url = new URL(url)
          console.log(analyze_url)
          analyze_url = analyze_url['hash']
          is_ok = this.check_is_array(conditional, analyze_url, val)
          if (is_ok) {
            result = is_ok
            return result
          }
          val = val.replace('#', '')
          result = this.rule_switch(conditional, analyze_url, val)
          break

        default:
          alert('未定義')
          break
      }
      return result
    },
    check_is_array(conditional, url, val) {
      let final = false
      if (Array.isArray(val)) {
        for (let i = 0; i < val.length; i++) {
          final = this.rule_switch(conditional, url, decodeURIComponent(val[i]))
          if (!final) {
            continue
          } else {
            break
          }
        }
        console.log('final', final)
        return final
      }
    },
    rule_switch(conditional, url, val) {
      let result = false
      let origin
      switch (conditional) {
        case '包含':
          console.log(url)
          console.log(val)
          if (val === '') return result
          result = url.includes(val)
          console.log(result)
          break

        case '不包含':
          if (val === '') return result
          result = !url.includes(val)
          console.log(result)
          break

        case '符合':
          if (val === '') return result
          console.log(url)
          console.log(val)
          origin = new URL(url).origin + new URL(url).pathname
          // console.log(origin);
          // console.log(origin.charAt(origin.length - 1));
          // origin.charAt(origin.length - 1) !== '/' ? origin + '/' : origin
          result = origin === val
          console.log(result)
          break

        case '不符合':
          if (val === '') return result
          console.log(url)
          console.log(val)
          origin = new URL(url).origin + new URL(url).pathname
          // console.log(origin.charAt(origin.length - 1));
          result = !origin === val
          console.log(result)
          break

        case '等於':
          if (val === '') return result
          result = url === val
          console.log(result)
          break

        case '不等於':
          if (val === '') return result
          result = !url === val
          console.log(result)
          break

        case '開頭是':
          if (val === '') return result
          result = url.startsWith(val)
          console.log(result)
          break

        case '結尾是':
          if (val === '') return result
          result = url.endsWith(val)
          console.log(result)
          break

        case '開頭不是':
          if (val === '') return result
          result = !url.startsWith(val)
          console.log(result)
          break

        case '結尾不是':
          if (val === '') return result
          result = !url.endsWith(val)
          console.log(result)
          break

        case '與規則運算式相符':
          if (val === '') return result
          console.log(val)
          console.log(url)
          result = this.$utils.validateByRegex(val, url)
          console.log(result)
          break

        case '與規則運算式不符':
          if (val === '') return result
          result = !this.$utils.validateByRegex(val, url)
          console.log(result)
          break

        case '與規則運算式相符(忽略大小寫)':
          if (val === '') return result
          console.log(val)
          console.log(url)
          result = this.$utils.validateByRegexIgnoreCase(val, url)
          console.log(result)
          break

        case '與規則運算式不符(忽略大小寫)':
          if (val === '') return result
          result = !this.$utils.validateByRegexIgnoreCase(val, url)
          console.log(result)
          break

        default:
          console.log('未定義的條件')
          alert('未定義的條件')
          break
      }
      return result
    },
    validateUrl(url) {
      this.$utils.validateUrl(decodeURIComponent(url)) ? (this.is_validate_url = false) : (this.is_validate_url = true)
      console.log(this.is_validate_url)
    },
    validateByRegex() {},
    submit: async function () {
      let result = this.$refs.form.validate()

      if (!result) {
        return
      }

      console.log(result)

      if (this.dialogSetting.views === null) {
        console.log(this.dialogSetting.title)
        console.log(this.dialogSetting.submit_callback)
        this.$emit(this.dialogSetting.submit_callback, this.dialogSetting.fields)
      } else {
        console.log(this.dialogSetting.title)
        console.log(this.dialogSetting.submit_callback)
        console.log(this.dialogSetting)
        let parse_priority_to_float = await this.dialogSetting.views.reduce((acc, cur) => {
          return [...acc, { ...cur, priority: `${Number(cur.priority) / 100}` }]
        }, [])
        console.log(this.dialogSetting.views)
        // this.now_rate = null;
        await this.$emit(this.dialogSetting.submit_callback, parse_priority_to_float)
      }
    },

    closeModal: function () {
      console.log(this.dialogSetting)

      this.dialogSetting.fields = this.dialogSetting.fields.map((item) => {
        if (item['grids']) {
          item['grids'] = item['grids'].map((grid) => {
            return { ...grid, is_show: false }
          })
        }
        return item
      })

      this.$emit(this.dialogSetting.close_callback, false)
    },
    async save(item) {
      console.log('save')
      console.log(item)
      this.edit_views_item = item
      let filter_views = await this.dialogSetting.views.filter((data) => {
        return data['id'] !== item['id']
      })
      console.log(filter_views)
      let all_priority = await filter_views.map((item) => {
        return Number(item['priority'])
      })
      console.log(all_priority)
      if (all_priority.length === 0) return
      let all_priority_sum = await all_priority.reduce((accumulator, currentValue) => accumulator + currentValue)
      console.log(all_priority_sum)
      this.now_rate = null
      this.now_rate = (await all_priority_sum) + Number(item.priority)
      console.log('this.now_rate', this.now_rate)
      console.log('this.dialogSetting.views', this.dialogSetting.views)
    },
    cancel() {
      console.log('cancel')
    },
    open() {
      console.log('open')
    },
    close() {
      console.log('close')
    },
    async calculate_now_rate(items) {
      let all_priority = await items.map((item) => {
        return Number(item['priority'])
      })
      let all_priority_sum = await all_priority.reduce((accumulator, currentValue) => accumulator + currentValue)
      this.now_rate = all_priority_sum
    },
    // registerGroup() {
    //   this.$emit('registerGroup', this.registerGroupToken)
    // },
    async registerGroup() {
      let param = { notify_platform: 'line' }

      await apiPatchRegisterGroup(this.selectedOrg.org_id, param)
        .then((resp) => {
          console.log(resp)
          this.$refs.body_script.value = `Optimize99綁定:${resp.data.data.token}`
        })
        .catch((error) => {
          console.log(error)
        })
    },
    async copyToClipboard(item) {
      try {
        let textToCopy
        switch (item) {
          case 'head_script':
            textToCopy = await this.$refs.head_script.value
            break
          case 'body_script':
            textToCopy = await this.$refs.body_script.value
            break
          default:
            break
        }
        await navigator.clipboard.writeText(textToCopy)
        console.log('已複製到剪贴板')
        this.snackbar = await true
        // setTimeout(() => {

        // }, 5000000);
      } catch (err) {
        console.error('無法複製: ', err)
      }
    },
    addChip(newValue) {
      console.log(newValue)
      console.log(this.dialogSetting.fields)
      if (newValue === null || newValue === '') {
        this.$root.vtoast.show({
          color: 'error',
          message: `不可新增空值！`,
        })
        return
      }
      let duplicate
      this.dialogSetting.fields.map((item) => {
        if (item.id === 'values') {
          duplicate = item.value.find((existingValue) => existingValue === item.newValue)
          if (duplicate !== undefined) {
            this.$root.vtoast.show({
              color: 'error',
              message: `新增到重複的值！`,
            })
          } else {
            item.value.push(item.newValue)
          }
        }
        return item
      })

      this.dialogSetting.fields.map((item) => {
        if (item.id === 'values') {
          item.newValue = null
        }
        return item
      })
    },
    removeChip(index) {
      console.log('刪除')
      this.dialogSetting.fields.map((item) => {
        if (item.id === 'values') {
          item.value.splice(index, 1)
          if (item.value.length > 1) {
            console.log(this.url_items)
            console.log(this.dialogSetting.fields[2]['newValue'])
            this.check_by_rule_str(this.dialogSetting.fields[2]['newValue'])
          }
          // else {
          //   this.$root.vtoast.show({
          //     message: "檢查的值不得為零",
          //     color: 'error'
          //   })
          // }
        }
        return item
      })
    },
    remove(index) {
      console.log(this.url_items)
      console.log(index)
      console.log('668行', '刪除')
      this.url_items = this.url_items.filter((item, itemIndex) => itemIndex !== index)
      console.log(this.url_items)
    },
    saveValue(key) {
      console.log('save')
      console.log('key', key)

      console.log(this.local)
      let val
      this.local.forEach((item) => {
        if (item.label === key.replace('活動', '')) {
          console.log('找到了')
          console.log(item.value)
          val = item.value

          this.local.forEach((item) => {
            if (item.label === key) {
              item.value = val
              console.log(item.value)
            }
          })
        }
      })
      console.log(this.local_date)
    },
    handleInput: function (item) {
      if (!item.label) {
        return
      }
      console.log('handleInput', item)
      let tmp_value = item.value

      if (item.label.includes('網址') || item.label.includes('編輯器頁面')) {
        try {
          tmp_value = decodeURIComponent(decodeURIComponent(decodeURIComponent(tmp_value)))
          console.log('???', tmp_value)
        } catch (error) {
          console.log('not_url')
        }
      }

      item.value = tmp_value
      console.log('item.value', item.value)
      this.update_key['text'] += 1
    },
  },
  watch: {
    // 同開始、結束時間按鈕的邏輯
    is_same(newVal) {
      if (newVal) {
        this.local.forEach((field) => {
          if (field.label === '開始時間') {
            this.local[this.local.length - 2]['grids'][0]['value'] = field['grids'][0]['value']
            this.local[this.local.length - 2]['grids'][1]['value'] = field['grids'][1]['value']
          }
          if (field.label === '結束時間') {
            this.local[this.local.length - 1]['grids'][0]['value'] = field['grids'][0]['value']
            this.local[this.local.length - 1]['grids'][1]['value'] = field['grids'][1]['value']
          }
        })
      } else {
        this.local[this.local.length - 1]['grids'][0]['value'] = null
        this.local[this.local.length - 1]['grids'][1]['value'] = null
        this.local[this.local.length - 2]['grids'][0]['value'] = null
        this.local[this.local.length - 2]['grids'][1]['value'] = null
      }
    },
    'dialogSetting.fields.0.value': {
      handler: function (newValue) {
        if (newValue && this.dialogSetting.title === '更新網址規則') {
          console.log(this.dialogSetting)
          this.$emit('updateDialogSetting', this.dialogSetting)
        }
      },
      deep: true,
    },
  },
}
</script>
<style scoped>
h4 {
  color: #5b5b5b;
}

span.v-btn__content {
  color: #5087e6 !important;
  caret-color: #5087e6 !important;
}

.list-enter-active,
.list-leave-active {
  transition: all 0.5s;
}

.list-enter,
.list-leave-to {
  opacity: 0;
  transform: translateY(30px);
}

.v-list-item .primary--text .v-list-item--active .v-list-item--link .theme--light .v-list-item--highlighted {
  color: #5087e6 !important;
  caret-color: #5087e6 !important;
}
.custom-chip {
  max-width: 500px; /* 調整chip的最大寬度 */
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
